"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSanityContext = exports.SanityContextProvider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const SanityContext = (0, react_1.createContext)({});
function SanityContextProvider(_a) {
    var { children } = _a, value = __rest(_a, ["children"]);
    return ((0, jsx_runtime_1.jsx)(SanityContext.Provider, Object.assign({ value: value }, { children: children })));
}
exports.SanityContextProvider = SanityContextProvider;
function useSanityContext() {
    return (0, react_1.useContext)(SanityContext);
}
exports.useSanityContext = useSanityContext;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU2FuaXR5Q29udGV4dC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL2hlbHAvc2FuaXR5L1Nhbml0eUNvbnRleHQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7OztBQUFBLGlDQUFxRTtBQVlyRSxNQUFNLGFBQWEsR0FBRyxJQUFBLHFCQUFhLEVBQ2pDLEVBQXdCLENBQ3pCLENBQUM7QUFFRixTQUFnQixxQkFBcUIsQ0FBQyxFQUdFO1FBSEYsRUFDcEMsUUFBUSxPQUU4QixFQURuQyxLQUFLLGNBRjRCLFlBR3JDLENBRFM7SUFFUixPQUFPLENBQ0wsdUJBQUMsYUFBYSxDQUFDLFFBQVEsa0JBQUMsS0FBSyxFQUFFLEtBQUssZ0JBQUcsUUFBUSxJQUEwQixDQUMxRSxDQUFDO0FBQ0osQ0FBQztBQVBELHNEQU9DO0FBRUQsU0FBZ0IsZ0JBQWdCO0lBQzlCLE9BQU8sSUFBQSxrQkFBVSxFQUFxQixhQUFhLENBQUMsQ0FBQztBQUN2RCxDQUFDO0FBRkQsNENBRUMifQ==